<template>
  <vx-card no-shadow>
    <h2 class="mb-6">Lessons</h2>

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="lessons"
      @selected="onLessonClicked(selected.lessonId)"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div
            @click="$router.push({ name: 'admin-survey-add-new-online-training-lesson', params: { surveyId: surveyId, moduleId: moduleId } }).catch(() => {})"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add Lesson</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ lessons.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : lessons.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Title</vs-th>
        <vs-th sort-key="duration">Duration</vs-th>
        <vs-th sort-key="canBeRedone">Can be redone</vs-th>
        <vs-th sort-key="numQuestions">Questions</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ $translate(tr.title) }}</p>
            </vs-td>

            <vs-td>
              <p>{{ tr.duration }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.canRedoLesson | yesno }}</p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getNumQuestionsColor(tr.numQuestions)"
                class="product-order-status"
              >{{ tr.numQuestions }}</vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="confirmDelete(tr.lessonId)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      surveyId: "",
      moduleId: "",

      query: "*",

      lessons: [],

      selected: [],
      itemsPerPage: 100,
      isMounted: false,

      itemIdToDelete: null
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.lessons.length;
    },
  },
  methods: {
    getLessons: function () {
      this.$vs.loading();

      const url =
        process.env.VUE_APP_API +
        "/Surveys/4/" +
        this.surveyId +
        "/modules/" +
        this.moduleId +
        "/Lessons?query=" +
        this.query;

      this.$http
        .get(url)
        .then((resp) => {
          console.log("Lessons: ", resp.data);
          this.lessons = resp.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onLessonClicked(lessonId) {
      this.$router
        .push({
          name: "admin-survey-online-training-lesson",
          params: {
            surveyId: this.surveyId,
            moduleId: this.moduleId,
            lessonId: lessonId,
          },
        })
        .catch(() => {});
    },

    confirmDelete(itemId) {
      this.itemIdToDelete = itemId;

      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete the Lesson?',
        accept: this.deleteItem
      })
      },
    deleteItem() {
      const url = process.env.VUE_APP_API +
        '/Surveys/' + 'OnlineTraining' + '/' + this.surveyId + 
        '/modules/' + this.moduleId + 
        '/lessons/' + this.itemIdToDelete;

      this.$http.delete(url)
        .then((/*resp*/) => {
          this.$vs.notify({
            color:'success',
            title:'Success',
            text:'Lesson deleted'
          });

         this.getLessons();
        })
        .catch(err => {
          console.log(err)

          this.$vs.notify({
            color:'danger',
            title:'Error',
            text:'Could not delete Lesson: ' + err
          });
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },

    editData(data) {
      console.log("Edit:", data);
    },

    getNumQuestionsColor(numQuestions) {
      if (numQuestions == 0) return "warning";
      return "success";
    },
    getStatusColor(status) {
      if (status === true) return "success";
      return "danger";
    },
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;

    this.getLessons();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
</style>